export enum DonorInfoFields {
  donorId = 'donorId',
  donorName = 'donorName',
}
